module.exports = __webpack_public_path__ + "static/media/dish2.f93f23ce.jpg";